import { useCallback, useEffect, useState } from 'react'
import { getApi } from '@BUP/services/Axios'

export const useGetSurveyTemplate = organizationId => {
  const [dataSurveyTemplate, setDataSurveyTemplate] = useState(null)
  const [isLoadingSurveyTemplate, setIsLoadingSurveyTemplate] = useState(false)
  const [errorSurveyTemplate, setErrorSurveyTemplate] = useState(null)

  const getTemplate = useCallback(async () => {
    setIsLoadingSurveyTemplate(true)
    const client = await getApi('sociogram', { authenticated: true })
    return client
      .get(
        `/type-survey-configs?isActive=true&sociograms.organizationId=${organizationId}`
      )
      .then(response => response.data)
      .then(data => setDataSurveyTemplate(data))
      .catch(error => {
        setErrorSurveyTemplate(error)
      })
      .finally(() => {
        setIsLoadingSurveyTemplate(false)
      })
  }, [
    setDataSurveyTemplate,
    setIsLoadingSurveyTemplate,
    setErrorSurveyTemplate,
    organizationId
  ])

  useEffect(() => {
    if (organizationId) {
      getTemplate()
    }
  }, [
    getTemplate,
    setDataSurveyTemplate,
    setIsLoadingSurveyTemplate,
    setErrorSurveyTemplate,
    organizationId
  ])

  return {
    dataSurveyTemplate,
    isLoadingSurveyTemplate,
    errorSurveyTemplate,
    getTemplate
  }
}
